// Syllable Counter Tool — count syllables in text (haiku & poetry helper).
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const syllableCounterTool: Tool = {
  id: "syllable-counter",
  name: () => m.syl_tool_name(),
  description: () => m.syl_tool_description(),
  icon: "🔤",
  basePath: "/syllable-counter",
  status: "stable",
  tags: ["writing", "poetry", "syllables", "haiku"],
  pages: [
    {
      name: () => m.syl_nav_main(),
      path: "/syllable-counter",
      description: () => m.syl_nav_main_desc(),
      icon: "🔤",
    },
    {
      name: () => m.syl_nav_haiku(),
      path: "/syllable-counter/haiku",
      description: () => m.syl_nav_haiku_desc(),
      icon: "🎋",
    },
  ],
};
